export default __webpack_public_path__ + "static/media/benchmaking_testseriesM.e366372f.png";